/**
 * The treatment categories, in the order the Treatments page shows them as
 * filter chips and the menu's Treatments dropdown lists them. Every
 * treatment on /ayurveda-treatments is in one of these. A category opens the
 * page already filtered: /ayurveda-treatments?category=<slug>.
 */
export const TREATMENT_CATEGORIES = [
  "Detox & Wellness",
  "Neurological Disorders",
  "Pain Management",
  "Musculoskeletal",
  "Digestive Health",
  "Respiratory Care",
  "Skin & Hair",
  "Women's Health",
  "Mental Health",
  "Metabolic",
  "Cardiovascular",
];

/** "Detox & Wellness" → "detox-and-wellness", "Women's Health" → "womens-health" */
export const categorySlug = (category: string) =>
  category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/'/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

/** the page a category opens */
export const categoryPath = (category: string) => `/ayurveda-treatments?category=${categorySlug(category)}`;
